/**
 * クラス名：板金のブランクのパンチ条件画面
 * 作成者：チュー
 * 作成日：2023/06/28
 * バージョン：1.0
 */
import React, { useEffect, forwardRef, useState } from 'react';
import { Table } from 'react-bootstrap';
import { Row, Col, Input, Select } from 'antd';
import { handleKeyPress, isDigit, isDigitZenkaku, regexExp, toHalfWidth } from '../../../common/Common';
import { WorkType } from '../../../common/enums';
const Device_Blank_PunchCondition = forwardRef((props, ref) => {
  const [editMode, setEditMode] = useState(false);
  const [punchConditionList, setPunchConditionList] = useState();
  const [workType, setWorkType] = useState();
  useEffect(() => {
    setEditMode(props.editMode);
    setWorkType(props?.processType);
    setPunchConditionList(props?.detailsData?.punches);
  }, [props.editMode, props.detailsData, props?.processType]);

  const changeValue = (id, value, isCheckZenkaku = true) => {
    if (regexExp.test(value) && !isDigitZenkaku(value)) return;
    if (isCheckZenkaku && regexExp.test(value)) {
      // 全角の場合、
      value = toHalfWidth(value); // 半角へ変換
      if (!isDigit(value)) return;
    }
    punchConditionList[id] = value;
    setPunchConditionList(punchConditionList);
    props.updateList(punchConditionList);
  };
  return (
    <>
      <Row className="chargeAmount" style={{ marginLeft: 10, marginRight: 10 }}>
        <Table style={{ width: workType === WorkType.SmBlankCombi ? '20%' : '60%' }}>
          <thead>
            <tr style={{ textAlign: 'center', verticalAlign: 'middle', height: 30 }}>
              <td style={{ width: '20%' }} className="param-tbl-header">
                1パンチ丸穴径
              </td>
              {workType === WorkType.SmBlankCombi ? (
                <></>
              ) : (
                <>
                  <td style={{ width: '20%' }} className="param-tbl-header">
                    1パンチ矩形周長
                  </td>
                  <td style={{ width: '20%' }} className="param-tbl-header">
                    二ブリングピッチ
                  </td>{' '}
                </>
              )}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                <Input
                  style={{ padding: 3, width: '98.2%', height: 26, textAlign: 'center' }}
                  className={editMode ? 'input-editable ' : 'input-non-editable'}
                  value={punchConditionList?.punchHoleDia}
                  onChange={(event) => changeValue('punchHoleDia', event.target.value, false)}
                  onBlur={(event) => changeValue('punchHoleDia', event.target.value)}
                  onPressEnter={(event) => changeValue('punchHoleDia', event.target.value)}
                  onKeyPress={(e) => {
                    handleKeyPress(e, false);
                  }}
                />
              </td>
              {workType === WorkType.SmBlankCombi ? (
                <></>
              ) : (
                <>
                  <td>
                    <Input
                      style={{ padding: 3, width: '98.2%', height: 26, textAlign: 'center' }}
                      className={editMode ? 'input-editable ' : 'input-non-editable'}
                      value={punchConditionList?.punchRectanglePer}
                      onChange={(event) => changeValue('punchRectanglePer', event.target.value, false)}
                      onBlur={(event) => changeValue('punchRectanglePer', event.target.value)}
                      onPressEnter={(event) => changeValue('punchRectanglePer', event.target.value)}
                      onKeyPress={(e) => {
                        handleKeyPress(e, false);
                      }}
                    />
                  </td>
                  <td>
                    <Input
                      style={{ padding: 3, width: '98.2%', height: 26, textAlign: 'center' }}
                      className={editMode ? 'input-editable ' : 'input-non-editable'}
                      value={punchConditionList?.twoPitch}
                      onChange={(event) => changeValue('twoPitch', event.target.value, false)}
                      onBlur={(event) => changeValue('twoPitch', event.target.value)}
                      onPressEnter={(event) => changeValue('twoPitch', event.target.value)}
                      onKeyPress={(e) => {
                        handleKeyPress(e, false);
                      }}
                    />
                  </td>{' '}
                </>
              )}
            </tr>
          </tbody>
        </Table>
      </Row>
    </>
  );
});

export default Device_Blank_PunchCondition;
